(function () {
  'use strict';

  var LOADING_TEXT = 'Loading…';

  function findProductList(fromEl) {
    var scope = fromEl.closest('.filters-adjacent.collection-listing') || document;
    return scope.querySelector('.product-list');
  }

  function handleClick(evt) {
    var btn = evt.target.closest('[data-load-more-btn]');
    if (!btn || btn.disabled) return;

    var nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl) return;

    var wrapper = btn.closest('[data-load-more-wrapper]');
    var productList = findProductList(btn);
    if (!productList) return;

    var label = btn.querySelector('[data-load-more-btn-label]');
    var originalLabel = label ? label.textContent : null;

    btn.disabled = true;
    btn.classList.add('load-more-btn--loading');
    if (label) label.textContent = LOADING_TEXT;

    fetch(nextUrl, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newProductList = doc.querySelector('.filters-adjacent.collection-listing .product-list');
        var appendedNodes = [];

        if (newProductList) {
          var childrenSnapshot = Array.prototype.slice.call(newProductList.children);
          childrenSnapshot.forEach(function (node) {
            appendedNodes.push(node);
            productList.appendChild(node);
          });
        }

        // re-init hover image swap, swatch monitoring, lazyload etc. on the new cards
        if (window.theme && theme.ProductBlockManager && appendedNodes.length) {
          theme.ProductBlockManager.loadImages($(appendedNodes));
        }

        var newBtn = doc.querySelector('[data-load-more-btn]');
        if (newBtn) {
          btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
          btn.disabled = false;
          btn.classList.remove('load-more-btn--loading');
          if (label) label.textContent = originalLabel;
        } else {
          if (wrapper) {
            wrapper.remove();
          } else {
            btn.remove();
          }
        }

        if (window.theme && typeof theme.initAnimateOnScroll === 'function') {
          theme.initAnimateOnScroll();
        }

        document.dispatchEvent(
          new CustomEvent('cc:load-more:appended', { detail: { container: productList } })
        );
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('load-more-btn--loading');
        if (label) label.textContent = originalLabel;
      });
  }

  document.addEventListener('click', handleClick);
})();